const layout = {
  xs: 12
};

export default {
  ref: 'users',
  title: 'Users',
  id: 'users',
  type: 'object',
  actions: {
    create: false,
    update: false,
    delete: false
  },
  properties: {
    displayName: {
      layout: {
        ...layout
      },
      type: 'string',
      label: 'Name',
      component: 'text'
    },
    email: {
      layout: {
        ...layout
      },
      type: 'email',
      label: 'Email',
      component: 'number'
    },
    lastLogin: {
      layout: {
        ...layout
      },
      type: 'string',
      label: 'Last Login',
      component: 'text'
    },
    ip: {
      layout: {
        ...layout
      },
      type: 'array',
      label: `IP's`,
      component: 'text'
    }
  }
};

export const mockData = {
  displayName: 'Woot',
  email: 'woot@woot.com'
};
